<template>
  <div>
    <div>
      <div class="mb-3">
        <b-card-text>
          <div class="container">
            <div class="justify-content-between icon">
              <trash-2-icon size="5x" class="delete" />
            </div>
          </div>
        </b-card-text>
        <hr />
        <b-card-text class="b-card-text">
          <p class="container"><b class="delete"> Delete </b> {{ name }}</p>
          <hr />
          <div class="container">
            <p>
              Are you sure you want to delete the selected {{ entityType }}?
              <span v-if="entityType === 'document'"> If deleted , This action cannot be undone.</span>
            </p>
            <p>Please type 'yes' to proceed</p>
            <b-input-group class="confirmation-spacing">
              <b-form-input v-model="confirmation" class="input_confirmation" size="sm" />
            </b-input-group>
          </div>
          <hr />
          <div class="d-flex">
            <b-button
              v-ripple.320="'rgba(40, 199, 111, 0.15)'"
              class="modal-button"
              size="sm"
              variant="outline-secondary"
              @click="closeDeleteConfirmation(false)"
            >
              Cancel
            </b-button>
            <b-button
              v-ripple.320="'rgba(40, 199, 111, 0.15)'"
              class="modal-button ml-auto"
              variant="danger"
              size="sm"
              :disabled="!validation"
              @click="
                deleteEntity()
                closeDeleteConfirmation(false)
                closeSidebar()
              "
            >
              Delete
            </b-button>
          </div>
        </b-card-text>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { BCardText, VBToggle, BButton, BFormInput, BInputGroup } from 'bootstrap-vue'
import { Trash2Icon } from 'vue-feather-icons'

export default {
  components: {
    BCardText,
    Trash2Icon,
    BButton,
    BFormInput,
    BInputGroup
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  props: {
    entityType: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      errorMessage: null,
      currentStore: null,
      name: null,
      confirmation: null
    }
  },
  computed: {
    ...mapState('organisationDetailsModal', ['organisation', 'showDeleteModal']),
    ...mapState('groupDetailsModal', ['group', 'showDeleteModal']),
    ...mapState('userDetailsModal', ['user', 'showDeleteModal']),
    validation: function () {
      return this.validateConfirmation(this.confirmation)
    }
  },
  created() {
    this.selectStore()
  },
  methods: {
    selectStore() {
      switch (this.entityType) {
        case 'organisation':
          this.currentStore = 'organisationDetailsModal'
          this.name = this.organisation.name
          break
        case 'group':
          this.currentStore = 'groupDetailsModal'
          this.name = this.group.name
          break
        case 'user':
          this.name = this.user.name
          this.currentStore = 'userDetailsModal'
      }
    },
    closeDeleteConfirmation(value) {
      this.$store.dispatch(this.currentStore + '/setShowDeleteModal', {
        self: this,
        visible: value
      })
    },
    deleteEntity() {
      this.$emit('deleteResponse', true)
    },
    closeSidebar() {
      this.$store.dispatch(this.currentStore + '/onChangeModal', {
        self: this,
        visible: false
      })
    },
    validateConfirmation(response) {
      if (response) {
        if (response.toLowerCase() === 'yes') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style>
.delete {
  color: #ea5455;
}
.container {
  text-align: center;
}
.button {
  display: flex;
  align-items: flex-start;
  padding-left: 45px;
  margin-right: 1.7%;
}

.b-card-text {
  padding-left: 15px;
  padding-right: 20px;
}
.confirmation-spacing {
  width: 65.5%;
  margin-left: 17.5%;
}
.input_confirmation {
  text-align: center;
}
</style>
